import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.agent');
import { OnInit, OnDestroy, Input, ViewChild, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Subscription } from 'rxjs';

declare const WizRoute: any;

// Showdown (Markdown 렌더링)
import showdown from 'showdown';

const APP_ID = 'page.agent';

// Markdown converter 설정
const mdConverter = new showdown.Converter({
    tables: true,
    ghCodeBlocks: true,
    tasklists: true,
    strikethrough: true,
    simplifiedAutoLink: true,
    openLinksInNewWindow: true,
});

// ── Block 기반 메시지 구조 ──

interface TextBlock {
    type: 'text';
    action_id?: string;
    content: string;
}

interface ToolBlock {
    type: 'tool';
    action_id?: string;
    id: string;
    name: string;
    summary: string;
    input: any;
    status: 'pending' | 'running' | 'complete' | 'error';
    result?: string;
    collapsed: boolean;
    canvasData?: any;
    canvasTool?: string;
}

interface AnalyzeBlock {
    type: 'analyze';
    action_id?: string;
    action: string;
    reasoning: string;
    summary: string;
    label: string;
    collapsed: boolean;
}

interface PlanBlock {
    type: 'plan';
    action_id?: string;
    steps: { step_id: number; title: string; status: string }[];
    collapsed: boolean;
}

interface StepBlock {
    type: 'step';
    action_id?: string;
    step_id: number;
    title: string;
    status: string;
    collapsed: boolean;
    stepNumber?: number;
}

interface ThinkingBlock {
    type: 'thinking';
    action_id?: string;
    content: string;
    collapsed: boolean;
}

interface SubAgentBlock {
    type: 'sub_agent';
    action_id?: string;
    task: string;
    status: 'running' | 'done' | 'failed';
    result?: string;
    collapsed: boolean;
}

interface PlanRetryBlock {
    type: 'plan_retry';
    action_id?: string;
    step_id: number;
    reason: string;
    collapsed: boolean;
}

interface PlanRevisionBlock {
    type: 'plan_revision';
    action_id?: string;
    mode: 'revise' | 'reconstruct';
    steps: any[];
    collapsed: boolean;
}

interface ContextSummaryBlock {
    type: 'context_summary';
    action_id?: string;
    summary: string;
    collapsed: boolean;
}

interface ReviewBlock {
    type: 'review';
    action_id?: string;
    action: string;
    reasoning: string;
    step_id: any;
    collapsed: boolean;
}

interface MicroReviewBlock {
    type: 'micro_review';
    action_id?: string;
    step_id: string;
    action: string;
    confidence: number;
    issue: string;
    collapsed: boolean;
}

interface EscalationBlock {
    type: 'escalation';
    action_id?: string;
    reason: string;
    detail: string;
    collapsed: boolean;
}

type MessageBlock = TextBlock | ToolBlock | AnalyzeBlock | PlanBlock | StepBlock | ThinkingBlock | SubAgentBlock | PlanRetryBlock | PlanRevisionBlock | ContextSummaryBlock | ReviewBlock | MicroReviewBlock | EscalationBlock;

interface ChatMessage {
    role: 'user' | 'assistant';
    content: string;
    blocks: MessageBlock[];
}

@Component({
    selector: 'wiz-page-agent',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.agent/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.mobile-menu-btn {
  display: none;
}

.mobile-overlay {
  display: none;
}

@media (max-width: 767px) {
  .mobile-menu-btn {
    display: flex;
  }
  .activity-bar {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 50;
    height: 100%;
    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.3);
  }
  .activity-bar.mobile-open {
    display: flex;
  }
  .mobile-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 40;
    background: rgba(0, 0, 0, 0.4);
  }
  .panel-area {
    width: 100% !important;
  }
  .resize-divider {
    display: none;
  }
  .chat-area.panel-active {
    display: none;
  }
}
.activity-bar button[data-tooltip]::before, .activity-bar button[data-tooltip]::after {
  position: absolute;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.15s ease, visibility 0.15s ease;
  z-index: 1000;
}
.activity-bar button[data-tooltip]::after {
  content: attr(data-tooltip);
  left: calc(100% + 10px);
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
  padding: 5px 10px;
  border-radius: 6px;
  background: #18181b;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.activity-bar button[data-tooltip]::before {
  content: "";
  left: calc(100% + 5px);
  top: 50%;
  transform: translateY(-50%);
  border: 5px solid transparent;
  border-right-color: #18181b;
}
.activity-bar button[data-tooltip]:hover::before, .activity-bar button[data-tooltip]:hover::after {
  opacity: 1;
  visibility: visible;
}

.storage-drag-over {
  background: rgba(59, 130, 246, 0.03);
}

.prose pre {
  background: #1e1e1e;
  color: #d4d4d4;
  border-radius: 8px;
  padding: 14px 16px;
  overflow-x: auto;
  font-size: 12px;
  line-height: 1.6;
  margin: 8px 0;
}
.prose pre code {
  background: transparent;
  padding: 0;
  color: inherit;
}
.prose code {
  background: #f3f4f6;
  color: #374151;
  padding: 2px 5px;
  border-radius: 4px;
  font-size: 12px;
}
.prose p {
  margin: 0.5em 0;
  line-height: 1.7;
}
.prose ul, .prose ol {
  margin: 0.5em 0;
  padding-left: 1.5em;
}
.prose li {
  margin: 0.25em 0;
}
.prose table {
  font-size: 13px;
  border-collapse: collapse;
  width: 100%;
  margin: 8px 0;
}
.prose table th, .prose table td {
  border: 1px solid #e5e7eb;
  padding: 6px 10px;
}
.prose table th {
  background: #f9fafb;
  font-weight: 500;
}
.prose h1, .prose h2, .prose h3, .prose h4 {
  margin-top: 1em;
  margin-bottom: 0.25em;
  font-weight: 600;
  color: #111827;
}
.prose blockquote {
  border-left: 3px solid #e5e7eb;
  padding-left: 12px;
  margin: 8px 0;
  color: #6b7280;
}
.prose a {
  color: #2563eb;
  text-decoration: none;
}
.prose a:hover {
  text-decoration: underline;
}
.prose hr {
  border: none;
  border-top: 1px solid #f3f4f6;
  margin: 16px 0;
}

.pipeline-flow {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pipeline-stage {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.pipeline-node {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 20px;
  border-radius: 6px;
  border: 1.5px solid #e5e7eb;
  background: #f9fafb;
  min-width: 120px;
  justify-content: center;
}
.pipeline-node--prompt {
  cursor: pointer;
  border-color: #bfdbfe;
  background: #eff6ff;
}
.pipeline-node--prompt:hover {
  border-color: #93c5fd;
  background: #dbeafe;
}
.pipeline-node--active {
  border-color: #3b82f6 !important;
  background: #dbeafe !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}
.pipeline-node--custom {
  border-color: #fcd34d;
  background: #fffbeb;
}
.pipeline-node--custom:hover {
  border-color: #f59e0b;
  background: #fef3c7;
}
.pipeline-node--static {
  background: #f9fafb;
  border-style: dashed;
}

.pipeline-connector {
  width: 1.5px;
  height: 20px;
  background: #d1d5db;
  position: relative;
}
.pipeline-connector::after {
  content: "";
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid #d1d5db;
}

.pipeline-branches {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
  justify-content: center;
}

.pipeline-branch-tag {
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 3px;
  background: #f3f4f6;
  color: #6b7280;
  white-space: nowrap;
}
.pipeline-branch-tag--next {
  background: #dbeafe;
  color: #2563eb;
  font-weight: 500;
}

.pipeline-badge {
  font-size: 9px;
  padding: 1px 5px;
  border-radius: 3px;
  background: #fef3c7;
  color: #92400e;
  font-weight: 500;
  white-space: nowrap;
}
.pipeline-badge--default {
  background: #f3f4f6;
  color: #6b7280;
}

.pipeline-aux-item {
  transition: background 0.15s ease;
}
.pipeline-aux-item:hover {
  background: #f9fafb;
}
.pipeline-aux-item--active {
  background: #eff6ff !important;
}

pre {
  margin: 0;
  word-break: break-all;
}

textarea {
  min-height: 40px;
  max-height: 160px;
}

@keyframes bounce-dot {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}
.welcome-card {
  cursor: pointer;
}
.welcome-card:active {
  transform: scale(0.98);
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}`],
})
export class PageAgentComponent implements OnInit, OnDestroy {
    @Input() title: any;
    @ViewChild('chatContainer') chatContainer: ElementRef;
    @ViewChild('chatInputRef') chatInputRef: ElementRef;
    @ViewChild('canvasIframe') canvasIframe: ElementRef;

    private routerSub: Subscription | null = null;

    // ── Chat 상태 ──
    public chatMessages: ChatMessage[] = [];
    public chatHistory: any[] = [];
    public chatInput: string = '';
    public chatLoading: boolean = false;
    public currentSessionId: string = '';
    public iterationCount: number = 0;
    public maxIterations: number = 5;

    // Settings 패널 (agent.json)
    public settingsJson: string = '';
    public settingsConfig: any = {};
    public settingsLoading: boolean = false;
    public settingsSaving: boolean = false;
    public settingsAdvancedMode: boolean = false;

    // 파이프라인 프롬프트
    public pipelinePrompts: any = {};
    public selectedPromptKey: string | null = null;
    public promptEditorTemplate: string = '';
    public promptEditorSaving: boolean = false;
    public settingsTab: string = 'general'; // 'general' | 'pipeline'

    // 모델 선택
    public providers: any[] = [];
    public selectedProvider: string = '';
    public selectedModel: string = '';
    public currentModels: any[] = [];

    // Activity Bar + Panel 시스템
    public activePanel: string | null = null;
    public panelWidth: number = 33;
    public isResizing: boolean = false;
    public mobileMenuOpen: boolean = false;
    public activityBarItems = [
        { id: 'chat', icon: 'chat', label: '채팅', tooltip: '채팅' },
        { id: 'storage', icon: 'storage', label: '스토리지', tooltip: '스토리지' },
        { id: 'canvas', icon: 'canvas', label: 'Canvas', tooltip: 'Canvas 결과' },
    ];

    // Canvas 패널
    public activeCanvas: ToolBlock | null = null;
    private canvasUrls: { [toolName: string]: SafeResourceUrl } = {};

    // Storage 상태 (User only)
    public storagePath: string = '/';
    public storageBreadcrumb: { name: string; path: string }[] = [];
    public storageFiles: any[] = [];
    public storageLoading: boolean = false;
    public isDraggingOver: boolean = false;
    public uploadProgress: { name: string; percent: number }[] = [];

    // 파일 뷰어/에디터 상태
    public storageFileViewer: {
        open: boolean;
        loading: boolean;
        saving: boolean;
        filename: string;
        path: string;
        content: string;
        originalContent: string;
        isImage: boolean;
        isBinary: boolean;
        mimeType: string;
        size: number;
        modified: boolean;
    } = {
        open: false, loading: false, saving: false,
        filename: '', path: '', content: '', originalContent: '',
        isImage: false, isBinary: false, mimeType: '', size: 0, modified: false,
    };

    // 드래그 앤 드롭 파일 이동 상태
    public storageDragItem: any = null;
    public storageDragOverFolder: string | null = null;

    // 컨텍스트 메뉴
    public contextMenu: { visible: boolean; x: number; y: number; item: any } = { visible: false, x: 0, y: 0, item: null };
    public storageFileTools: any[] = [];
    public storageToolsLoading: boolean = false;

    // Canvas 컨텍스트 (iframe에서 수집)
    public canvasContext: any = null;

    @ViewChild('storageFileInput') storageFileInput: ElementRef;

    // History 패널
    public historyList: any[] = [];
    public historyLoading: boolean = false;

    // Tools 패널
    public toolsList: any[] = [];
    public toolsLoading: boolean = false;
    public expandedTools: Set<string> = new Set();
    public disabledTools: string[] = [];
    public toolDetail: any = null;
    public toolDetailMode: boolean = false;
    public toolTestInput: string = '{}';
    public toolTestResult: string = '';
    public toolTestRunning: boolean = false;
    public toolSearchQuery: string = '';

    // 인라인 입력 모달 (prompt 대체)
    public promptModal: { visible: boolean; title: string; value: string; placeholder: string; resolve: ((val: string | null) => void) | null } = { visible: false, title: '', value: '', placeholder: '', resolve: null };

    // 자동 스크롤
    public isUserScrolledUp: boolean = false;

    // Plan 상단 고정
    public activePlan: { step_id: number; title: string; status: string }[] = [];
    public planExpanded: boolean = false;

    // IME 조합 상태
    public isComposing: boolean = false;

    // 동적 로딩 상태
    public hasMoreMessages: boolean = false;
    public oldestMessageId: number | null = null;
    public loadingOlderMessages: boolean = false;
    public totalMessageCount: number = 0;
    private readonly MESSAGES_PER_PAGE: number = 20;

    private chatAbortController: AbortController | null = null;
    private chatAssistantIdx: number = -1;

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef)         private cdr: ChangeDetectorRef,@Inject( DomSanitizer)         private sanitizer: DomSanitizer,@Inject( Router)         private router: Router,    ) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadProviders();
        this.setupCanvasListener();

        // URL에서 세션 ID 확인
        const urlSessionId = WizRoute.segment?.session_id;
        if (urlSessionId) {
            this.currentSessionId = urlSessionId;
            await this.loadSessionFromId(urlSessionId);
        } else {
            this.generateSessionId();
        }

        // 라우팅 변경 감지 (같은 컴포넌트 재사용 대응)
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newSessionId = WizRoute.segment?.session_id;
                if (newSessionId && newSessionId !== this.currentSessionId) {
                    this.currentSessionId = newSessionId;
                    await this.loadSessionFromId(newSessionId);
                }
            }
        });

        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    // =========================================================================
    // Session Management
    // =========================================================================

    private generateSessionId() {
        const now = new Date();
        const pad = (n: number) => n.toString().padStart(2, '0');
        this.currentSessionId = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
    }

    public startNewSession() {
        this.chatMessages = [];
        this.chatHistory = [];
        this.chatAssistantIdx = -1;
        this.activeCanvas = null;
        this.activePlan = [];
        this.planExpanded = false;
        this.hasMoreMessages = false;
        this.oldestMessageId = null;
        this.totalMessageCount = 0;
        this.generateSessionId();
        if (this.activePanel === 'canvas') {
            this.activePanel = null;
        }
        this.updateUrlSessionId();
        this.cdr.detectChanges();
    }

    private updateUrlSessionId() {
        this.service.href(`/agent/${this.currentSessionId}`);
    }

    private async loadSessionFromId(sessionId: string) {
        try {
            // 최근 N건만 먼저 로드
            const res = await wiz.call('conversation_load', {
                session_id: sessionId,
                limit: String(this.MESSAGES_PER_PAGE),
            });
            const data = res.data?.session;
            if (data && data.messages && data.messages.length > 0) {
                this.restoreSessionData(data);
            }
        } catch (e) {
            // 세션이 없으면 새 세션으로 시작
        }
    }

    public async loadOlderMessages() {
        if (this.loadingOlderMessages || !this.hasMoreMessages || !this.oldestMessageId) return;
        this.loadingOlderMessages = true;
        this.cdr.detectChanges();

        try {
            const res = await wiz.call('conversation_load', {
                session_id: this.currentSessionId,
                before_id: String(this.oldestMessageId),
                limit: String(this.MESSAGES_PER_PAGE),
            });
            const data = res.data?.session;
            if (data && data.messages && data.messages.length > 0) {
                const olderMessages: ChatMessage[] = [];
                for (const m of data.messages) {
                    const blocks = this.deserializeBlocks(m.blocks, m.content);
                    olderMessages.push({ role: m.role, content: m.content || '', blocks });
                }

                // 스크롤 위치 보존
                const container = this.chatContainer?.nativeElement;
                const prevScrollHeight = container ? container.scrollHeight : 0;

                // 앞쪽에 삽입
                this.chatMessages = [...olderMessages, ...this.chatMessages];

                // chatHistory도 앞쪽에 삽입
                const olderHistory = data.messages.map((m: any) => ({ role: m.role, content: m.content || '' }));
                this.chatHistory = [...olderHistory, ...this.chatHistory];

                // oldest ID 갱신
                if (data.messages.length > 0) {
                    this.oldestMessageId = data.messages[0].id;
                }
                this.hasMoreMessages = data.has_more || false;

                this.cdr.detectChanges();

                // 스크롤 위치 복원
                if (container) {
                    const newScrollHeight = container.scrollHeight;
                    container.scrollTop = newScrollHeight - prevScrollHeight;
                }
            } else {
                this.hasMoreMessages = false;
            }
        } catch (e) {
            console.error('Load older messages error:', e);
        } finally {
            this.loadingOlderMessages = false;
            this.cdr.detectChanges();
        }
    }

    private restoreSessionData(data: any) {
        const messages = data.messages || [];
        this.chatMessages = [];
        this.chatHistory = [];
        for (const m of messages) {
            const blocks = this.deserializeBlocks(m.blocks, m.content);
            this.chatMessages.push({ role: m.role, content: m.content || '', blocks });
            this.chatHistory.push({ role: m.role, content: m.content || '' });
        }
        this.chatAssistantIdx = -1;
        this.activeCanvas = null;
        this.activePlan = [];
        this.planExpanded = false;
        if (this.activePanel === 'canvas') this.activePanel = null;

        // 동적 로딩 상태 초기화
        this.totalMessageCount = data.total_count || messages.length;
        this.hasMoreMessages = data.has_more || false;
        if (messages.length > 0 && messages[0].id) {
            this.oldestMessageId = messages[0].id;
        } else {
            this.oldestMessageId = null;
        }

        this.cdr.detectChanges();
    }

    private deserializeBlocks(blocks: any[], fallbackContent: string): MessageBlock[] {
        if (!blocks || blocks.length === 0) {
            return fallbackContent ? [{ type: 'text', content: fallbackContent }] : [];
        }
        return blocks.map((b: any) => {
            const aid = b.action_id || undefined;
            switch (b.type) {
                case 'text':
                    return { type: 'text', action_id: aid, content: b.content || '' } as TextBlock;
                case 'tool':
                    return { type: 'tool', action_id: aid, id: b.id || '', name: b.name || '', summary: b.summary || '', input: b.input || {}, status: b.status || 'complete', result: b.result || '', collapsed: true, canvasData: b.canvasData || null, canvasTool: b.canvasTool || null } as ToolBlock;
                case 'analyze':
                    return { type: 'analyze', action_id: aid, action: b.action || '', reasoning: b.reasoning || '', summary: b.summary || '', label: b.label || '의도 분석', collapsed: true } as AnalyzeBlock;
                case 'plan':
                    return { type: 'plan', action_id: aid, steps: b.steps || [], collapsed: true } as PlanBlock;
                case 'step':
                    return { type: 'step', action_id: aid, step_id: b.step_id || 0, title: b.title || '', status: b.status || 'done', collapsed: true } as StepBlock;
                case 'thinking':
                    return { type: 'thinking', action_id: aid, content: b.content || '', collapsed: true } as ThinkingBlock;
                case 'sub_agent':
                    return { type: 'sub_agent', action_id: aid, task: b.task || '', status: b.status || 'done', result: b.result || '', collapsed: true } as SubAgentBlock;
                case 'plan_retry':
                    return { type: 'plan_retry', action_id: aid, step_id: b.step_id || 0, reason: b.reason || '', collapsed: true } as PlanRetryBlock;
                case 'plan_revision':
                    return { type: 'plan_revision', action_id: aid, mode: b.mode || 'revise', steps: b.steps || [], collapsed: true } as PlanRevisionBlock;
                case 'context_summary':
                    return { type: 'context_summary', action_id: aid, summary: b.summary || '', collapsed: true } as ContextSummaryBlock;
                case 'review':
                    return { type: 'review', action_id: aid, action: b.action || '', reasoning: b.reasoning || '', step_id: b.step_id, collapsed: true } as ReviewBlock;
                case 'micro_review':
                    return { type: 'micro_review', action_id: aid, step_id: b.step_id || '', action: b.action || '', confidence: b.confidence || 0, issue: b.issue || '', collapsed: true } as MicroReviewBlock;
                case 'escalation':
                    return { type: 'escalation', action_id: aid, reason: b.reason || '', detail: b.detail || '', collapsed: true } as EscalationBlock;
                default:
                    return { type: 'text', action_id: aid, content: b.content || '' } as TextBlock;
            }
        });
    }

    // =========================================================================
    // Modal Helpers (시스템 다이얼로그 대체)
    // =========================================================================

    public showPrompt(title: string, placeholder: string = '', defaultValue: string = ''): Promise<string | null> {
        return new Promise((resolve) => {
            this.promptModal = { visible: true, title, value: defaultValue, placeholder, resolve };
            this.cdr.detectChanges();
        });
    }

    public promptConfirm() {
        if (this.promptModal.resolve) this.promptModal.resolve(this.promptModal.value);
        this.promptModal = { visible: false, title: '', value: '', placeholder: '', resolve: null };
        this.cdr.detectChanges();
    }

    public promptCancel() {
        if (this.promptModal.resolve) this.promptModal.resolve(null);
        this.promptModal = { visible: false, title: '', value: '', placeholder: '', resolve: null };
        this.cdr.detectChanges();
    }

    public async showConfirm(message: string): Promise<boolean> {
        const res = await this.service.modal.show({
            title: '확인',
            message: message,
            action: '확인',
            actionBtn: 'warning',
            cancel: '취소',
            status: 'warning'
        });
        return res !== false && res !== undefined;
    }

    // =========================================================================
    // Chat Core
    // =========================================================================

    public async sendExample(text: string) {
        this.chatInput = text;
        await this.service.render();
        await this.sendChat();
    }

    public async sendChat() {
        const message = this.chatInput.trim();
        if (!message || this.chatLoading) return;

        // 1. UI 상태 업데이트
        this.chatMessages.push({ role: 'user', content: message, blocks: [] });
        this.chatInput = '';

        // textarea 강제 초기화 (IME 잔류 방지)
        if (this.chatInputRef?.nativeElement) {
            this.chatInputRef.nativeElement.value = '';
        }

        this.chatLoading = true;
        this.isUserScrolledUp = false;
        this.chatAbortController = new AbortController();

        // 2. 빈 assistant 메시지 (스트리밍으로 블록 누적)
        const assistantMsg: ChatMessage = {
            role: 'assistant',
            content: '',
            blocks: [],
        };
        this.chatMessages.push(assistantMsg);
        this.chatAssistantIdx = this.chatMessages.length - 1;

        // 3. Canvas 컨텍스트 수집 (활성 Canvas가 있으면 요청)
        let canvasContextData: any = null;
        if (this.activeCanvas && this.canvasIframe?.nativeElement) {
            try {
                canvasContextData = await this.requestCanvasContext();
            } catch (e) {
                // 컨텍스트 수집 실패 시 무시
            }
        }
        // 기존 저장된 컨텍스트도 활용
        if (!canvasContextData && this.canvasContext) {
            canvasContextData = this.canvasContext;
        }

        // 4. form-urlencoded body
        const params = new URLSearchParams();
        params.append('session_id', this.currentSessionId);
        params.append('message', message);
        params.append('history', JSON.stringify(this.chatHistory));
        if (this.selectedProvider) params.append('provider', this.selectedProvider);
        if (this.selectedModel) params.append('model', this.selectedModel);
        if (canvasContextData) {
            params.append('canvas_context', JSON.stringify(canvasContextData));
        }

        try {
            // 5. fetch + SSE
            const response = await fetch(
                `/wiz/api/${APP_ID}/agent_chat`,
                {
                    method: 'POST',
                    body: params,
                    signal: this.chatAbortController.signal
                }
            );

            // 5. ReadableStream 처리
            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';

                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const event = JSON.parse(line.slice(6));
                            this.handleChatEvent(event);
                        } catch (e) {
                            console.error('SSE parse error:', e);
                        }
                    }
                }
            }
        } catch (e: any) {
            if (e.name !== 'AbortError') {
                const msg = this.chatMessages[this.chatAssistantIdx];
                this._appendTextToBlocks(msg, `\n\n**Error:** ${e.message}`);
            }
        } finally {
            this.chatLoading = false;
            this.chatAbortController = null;
            this.scrollToBottom();
            await this.service.render();
        }
    }

    private handleChatEvent(event: any) {
        const msg = this.chatMessages[this.chatAssistantIdx];
        const actionId = event.action_id || undefined;

        switch (event.type) {
            case 'text': {
                // 실행 순서 보존: 마지막 블록이 같은 action_id의 TextBlock이면 append,
                // 그 사이에 tool 등 다른 블록이 끼었으면 새 TextBlock 생성
                const blocks = msg.blocks;
                const last = blocks.length > 0 ? blocks[blocks.length - 1] : null;
                let textBlock: TextBlock;
                if (last && last.type === 'text' && (last as any).action_id === actionId) {
                    textBlock = last as TextBlock;
                } else {
                    textBlock = { type: 'text', action_id: actionId, content: '', collapsed: false } as TextBlock;
                    blocks.push(textBlock);
                }
                textBlock.content += (event.content || '');
                this.scrollToBottom();
                break;
            }

            case 'thinking': {
                // 실행 순서 보존: 마지막 블록이 같은 action_id의 ThinkingBlock이면 append
                const blocks = msg.blocks;
                const last = blocks.length > 0 ? blocks[blocks.length - 1] : null;
                let thinkBlock: ThinkingBlock;
                if (last && last.type === 'thinking' && (last as any).action_id === actionId) {
                    thinkBlock = last as ThinkingBlock;
                } else {
                    thinkBlock = { type: 'thinking', action_id: actionId, content: '', collapsed: true } as ThinkingBlock;
                    blocks.push(thinkBlock);
                }
                thinkBlock.content += (event.content || '');
                this.scrollToBottom();
                break;
            }

            case 'analyze':
                msg.blocks.push({
                    type: 'analyze',
                    action_id: actionId,
                    action: event.action,
                    reasoning: event.reasoning || '',
                    summary: event.summary || '',
                    label: event.label || '의도 분석',
                    collapsed: false,
                } as AnalyzeBlock);
                this.scrollToBottom();
                break;

            case 'plan':
                this.activePlan = event.steps;
                this.planExpanded = false;
                {
                    const existing = this._findBlockByActionId(msg, actionId, 'plan')
                        || msg.blocks.find(b => b.type === 'plan') as PlanBlock | undefined;
                    if (existing && existing.type === 'plan') {
                        (existing as PlanBlock).steps = event.steps;
                    } else {
                        msg.blocks.push({
                            type: 'plan',
                            action_id: actionId,
                            steps: event.steps,
                            collapsed: true,
                        } as PlanBlock);
                    }
                }
                this.scrollToBottom();
                break;

            case 'plan_update':
                {
                    const activeStep = this.activePlan.find(s => s.step_id === event.step_id);
                    if (activeStep) activeStep.status = event.status;

                    const planBlock = msg.blocks.find(b => b.type === 'plan') as PlanBlock | undefined;
                    if (planBlock) {
                        const step = planBlock.steps.find(s => s.step_id === event.step_id);
                        if (step) step.status = event.status;
                    }

                    if (event.status === 'in_progress' && event.title) {
                        msg.blocks.push({
                            type: 'step',
                            action_id: actionId,
                            step_id: event.step_id,
                            title: event.title,
                            status: 'in_progress',
                            collapsed: false,
                            stepNumber: event.step_number || 0,
                        } as StepBlock);
                    }

                    if (event.status === 'done' || event.status === 'failed' || event.status === 'invalidated' || event.status === 'skipped') {
                        // action_id 기반 매칭 우선, fallback으로 step_id 매칭
                        let matchIdx = -1;
                        if (actionId) {
                            matchIdx = msg.blocks.findIndex(
                                b => b.type === 'step' && (b as StepBlock).action_id === actionId
                            );
                        }
                        if (matchIdx < 0) {
                            matchIdx = this._findLastStepBlockIndex(msg.blocks, event.step_id, 'in_progress');
                        }
                        if (matchIdx >= 0) {
                            const stepBlock = msg.blocks[matchIdx] as StepBlock;
                            stepBlock.status = event.status;
                            stepBlock.collapsed = true;
                        }
                    }
                }
                this.scrollToBottom();
                break;

            case 'step_done': {
                // action_id 기반 StepBlock 완료 처리
                const stepBlock = this._findBlockByActionId(msg, actionId, 'step');
                if (stepBlock && stepBlock.type === 'step') {
                    (stepBlock as StepBlock).status = 'done';
                    (stepBlock as StepBlock).collapsed = true;
                }
                this.scrollToBottom();
                break;
            }

            case 'tool_use':
                msg.blocks.push({
                    type: 'tool',
                    action_id: actionId,
                    id: event.id,
                    name: event.name,
                    summary: this._generateToolSummary(event.name, event.input),
                    input: event.input,
                    status: 'pending',
                    collapsed: false,
                });
                this.scrollToBottom();
                break;

            case 'tool_result': {
                let canvasData: any = null;
                let canvasTool: string | null = null;
                let displayResult = event.result;
                try {
                    const parsed = JSON.parse(event.result);
                    if (parsed.canvas && parsed.data) {
                        canvasData = parsed.data;
                        canvasTool = event.name;
                        displayResult = parsed.text || event.result;
                    }
                } catch (e) {
                    // 일반 텍스트 결과
                }

                // tool_use_id(event.id)로 우선 매칭 (Action 내 복수 도구 호출 지원)
                let toolBlock: ToolBlock | undefined;
                if (event.id) {
                    toolBlock = msg.blocks.find(
                        b => b.type === 'tool' && (b as ToolBlock).id === event.id
                    ) as ToolBlock | undefined;
                }
                // fallback: action_id로 매칭 (미완료 상태만)
                if (!toolBlock && actionId) {
                    toolBlock = msg.blocks.find(
                        b => b.type === 'tool' && (b as any).action_id === actionId && (b as ToolBlock).status !== 'complete'
                    ) as ToolBlock | undefined;
                }

                if (toolBlock) {
                    toolBlock.result = displayResult;
                    toolBlock.status = 'complete';
                    toolBlock.collapsed = true;
                    if (canvasData) toolBlock.canvasData = canvasData;
                    if (canvasTool) toolBlock.canvasTool = canvasTool;

                    if (canvasData && canvasTool) {
                        this.openCanvas(toolBlock);
                    }
                }
                this.scrollToBottom();
                break;
            }

            case 'history':
                this.chatHistory = event.messages;
                break;

            case 'done':
                this.activePlan = [];
                this.planExpanded = false;
                this.iterationCount = 0;
                this.autoCollapseTools();
                this._collapseCurrentTurnWorkBlocks(msg);
                this.scrollToBottom();
                this.saveConversationLog();
                break;

            case 'error':
                this._appendTextToBlocks(msg, `\n\n**Error:** ${event.message}`);
                break;

            case 'iteration_update':
                this.iterationCount = event.current || 0;
                this.maxIterations = event.max || 5;
                break;

            case 'context_summary':
                msg.blocks.push({
                    type: 'context_summary',
                    action_id: actionId,
                    summary: event.summary || '',
                    collapsed: true,
                } as ContextSummaryBlock);
                this.scrollToBottom();
                break;

            case 'plan_retry':
                msg.blocks.push({
                    type: 'plan_retry',
                    action_id: actionId,
                    step_id: event.step_id,
                    reason: event.reason || '',
                    collapsed: false,
                } as PlanRetryBlock);
                // 기존 진행 중 StepBlock을 failed로 변경
                {
                    const failedStepBlock = [...msg.blocks].reverse().find(
                        b => b.type === 'step' && (b as StepBlock).step_id === event.step_id && (b as StepBlock).status === 'in_progress'
                    ) as StepBlock | undefined;
                    if (failedStepBlock) {
                        failedStepBlock.status = 'failed';
                        failedStepBlock.collapsed = true;
                    }
                }
                // activePlan에서 해당 step을 pending으로 리셋
                {
                    const retryStep = this.activePlan.find(s => s.step_id === event.step_id);
                    if (retryStep) retryStep.status = 'pending';
                }
                this.scrollToBottom();
                break;

            case 'plan_revision':
                // 현재 진행 중인 모든 StepBlock을 invalidated로 변경
                for (const block of msg.blocks) {
                    if (block.type === 'step' && (block as StepBlock).status === 'in_progress') {
                        (block as StepBlock).status = 'invalidated';
                        (block as StepBlock).collapsed = true;
                    }
                }
                msg.blocks.push({
                    type: 'plan_revision',
                    action_id: actionId,
                    mode: event.mode || 'revise',
                    steps: event.steps || [],
                    collapsed: false,
                } as PlanRevisionBlock);
                // activePlan 갱신
                if (event.steps) {
                    this.activePlan = event.steps;
                    const planBlock = msg.blocks.find(b => b.type === 'plan') as PlanBlock | undefined;
                    if (planBlock) planBlock.steps = event.steps;
                }
                this.scrollToBottom();
                break;

            case 'review_decision':
            case 'review':
                msg.blocks.push({
                    type: 'review',
                    action_id: actionId,
                    action: event.action || 'continue',
                    reasoning: event.reasoning || '',
                    step_id: event.step_id,
                    collapsed: true,
                } as ReviewBlock);
                this.scrollToBottom();
                break;

            case 'micro_review':
                msg.blocks.push({
                    type: 'micro_review',
                    action_id: actionId,
                    step_id: event.step_id || '',
                    action: event.action || 'continue',
                    confidence: event.confidence || 0,
                    issue: event.issue || '',
                    collapsed: true,
                } as MicroReviewBlock);
                this.scrollToBottom();
                break;

            case 'learning_complete':
                // 학습 완료 알림 — 별도 블록 불필요, 무시
                break;

            case 'escalation':
                {
                    let reason = event.reason || '';
                    let detail = '';
                    if (reason === 'system2_to_system1') {
                        detail = `Pattern: ${event.pattern_description || ''} (success: ${event.success_count || 0})`;
                    } else {
                        detail = `Turn: ${event.turn_count || 0}`;
                    }
                    msg.blocks.push({
                        type: 'escalation',
                        action_id: actionId,
                        reason,
                        detail,
                        collapsed: true,
                    } as EscalationBlock);
                    this.scrollToBottom();
                }
                break;

            case 'sub_agent_start':
                msg.blocks.push({
                    type: 'sub_agent',
                    action_id: actionId,
                    task: event.task || '',
                    status: 'running',
                    collapsed: false,
                } as SubAgentBlock);
                this.scrollToBottom();
                break;

            case 'sub_agent_end':
                {
                    // action_id 기반 매칭 우선
                    let subBlock: SubAgentBlock | undefined;
                    if (actionId) {
                        subBlock = this._findBlockByActionId(msg, actionId, 'sub_agent') as SubAgentBlock | undefined;
                    }
                    if (!subBlock) {
                        subBlock = [...msg.blocks].reverse().find(
                            b => b.type === 'sub_agent' && (b as SubAgentBlock).status === 'running'
                        ) as SubAgentBlock | undefined;
                    }
                    if (subBlock) {
                        subBlock.status = 'done';
                        subBlock.result = event.result || '';
                        subBlock.collapsed = true;
                    }
                }
                this.scrollToBottom();
                break;
        }

        this.cdr.detectChanges();
    }

    // ── action_id 기반 블록 매칭 헬퍼 ──

    private _findBlockByActionId(msg: ChatMessage, actionId: string | undefined, blockType?: string): MessageBlock | null {
        if (!actionId) return null;
        for (const block of msg.blocks) {
            if ((block as any).action_id === actionId) {
                if (!blockType || block.type === blockType) return block;
            }
        }
        return null;
    }

    private _findOrCreateBlock(msg: ChatMessage, actionId: string | undefined, blockType: string, defaults: any): MessageBlock {
        // action_id가 있으면 기존 블록 검색
        if (actionId) {
            const existing = this._findBlockByActionId(msg, actionId, blockType);
            if (existing) return existing;
        }
        // action_id가 없으면 기존 type 기반 fallback (마지막 같은 타입 블록)
        if (!actionId) {
            const blocks = msg.blocks;
            const last = blocks.length > 0 ? blocks[blocks.length - 1] : null;
            if (last && last.type === blockType) return last;
        }
        // 새 블록 생성
        const block = { type: blockType, action_id: actionId, ...defaults };
        msg.blocks.push(block);
        return block;
    }

    private _appendTextToBlocks(msg: ChatMessage, text: string) {
        const blocks = msg.blocks;
        const last = blocks.length > 0 ? blocks[blocks.length - 1] : null;
        if (last && last.type === 'text') {
            (last as TextBlock).content += text;
        } else {
            blocks.push({ type: 'text', content: text });
        }
    }

    public cancelChat() {
        if (this.chatAbortController) {
            this.chatAbortController.abort();
            this.chatAbortController = null;
        }
        this.chatLoading = false;
    }

    public clearChat() {
        this.startNewSession();
    }

    // =========================================================================
    // Tool 접기
    // =========================================================================

    private autoCollapseTools() {
        for (let i = 0; i < this.chatMessages.length - 1; i++) {
            const msg = this.chatMessages[i];
            if (msg.role === 'assistant') {
                for (const block of msg.blocks) {
                    if (block.type === 'tool' || block.type === 'analyze' || block.type === 'plan' || block.type === 'step' || block.type === 'thinking' || block.type === 'sub_agent' || block.type === 'plan_retry' || block.type === 'plan_revision' || block.type === 'context_summary' || block.type === 'review' || block.type === 'micro_review' || block.type === 'escalation') {
                        block.collapsed = true;
                    }
                }
            }
        }
    }

    private _collapseCurrentTurnWorkBlocks(msg: ChatMessage) {
        for (const block of msg.blocks) {
            if (block.type === 'tool' || block.type === 'analyze' || block.type === 'plan' || block.type === 'step' || block.type === 'thinking' || block.type === 'sub_agent' || block.type === 'plan_retry' || block.type === 'plan_revision' || block.type === 'context_summary' || block.type === 'review' || block.type === 'micro_review' || block.type === 'escalation') {
                block.collapsed = true;
            }
        }
    }

    public toggleToolBlock(block: ToolBlock | AnalyzeBlock | PlanBlock | StepBlock | ThinkingBlock | SubAgentBlock | PlanRetryBlock | PlanRevisionBlock | ContextSummaryBlock | ReviewBlock | MicroReviewBlock | EscalationBlock) {
        block.collapsed = !block.collapsed;
    }

    public getStepChildBlocks(msg: ChatMessage, stepBlock: StepBlock): MessageBlock[] {
        const blocks = msg.blocks;
        const stepIdx = blocks.indexOf(stepBlock);
        if (stepIdx < 0) return [];

        const children: MessageBlock[] = [];
        for (let i = stepIdx + 1; i < blocks.length; i++) {
            const b = blocks[i];
            if (b.type === 'step' || b.type === 'plan' || b.type === 'analyze') break;
            children.push(b);
        }
        return children;
    }

    public isBlockHiddenByStep(msg: ChatMessage, blockIdx: number): boolean {
        const blocks = msg.blocks;
        const current = blocks[blockIdx];
        if (current.type === 'step' || current.type === 'plan' || current.type === 'analyze') return false;

        // 현재 블록 뒤에 step 블록이 하나도 없으면 최종 응답(final_synthesis) 영역이므로 숨기지 않음
        let hasStepAfter = false;
        for (let i = blockIdx + 1; i < blocks.length; i++) {
            if (blocks[i].type === 'step') { hasStepAfter = true; break; }
        }
        if (!hasStepAfter) return false;

        for (let i = blockIdx - 1; i >= 0; i--) {
            const b = blocks[i];
            if (b.type === 'step') {
                return (b as StepBlock).collapsed;
            }
            if (b.type === 'plan' || b.type === 'analyze') return false;
        }
        return false;
    }

    private _findLastStepBlockIndex(blocks: MessageBlock[], stepId: any, matchStatus?: string): number {
        for (let i = blocks.length - 1; i >= 0; i--) {
            const b = blocks[i];
            if (b.type === 'step' && (b as StepBlock).step_id === stepId) {
                if (!matchStatus || (b as StepBlock).status === matchStatus) {
                    return i;
                }
            }
        }
        return -1;
    }

    public getActivePlanSummary(): string {
        const inProgress = this.activePlan.find(s => s.status === 'in_progress');
        if (inProgress) return inProgress.title;
        const pending = this.activePlan.find(s => s.status === 'pending');
        if (pending) return pending.title;
        const done = this.activePlan.filter(s => s.status === 'done');
        if (done.length === this.activePlan.length && done.length > 0) return '모든 단계 완료';
        return this.activePlan[0]?.title || '';
    }

    public getActivePlanProgress(): string {
        const done = this.activePlan.filter(s => s.status === 'done').length;
        return `${done}/${this.activePlan.length}`;
    }

    public toggleAllTools(msg: ChatMessage) {
        const toolBlocks = msg.blocks.filter(
            b => b.type === 'tool'
        ) as ToolBlock[];
        if (toolBlocks.length === 0) return;
        const allCollapsed = toolBlocks.every(b => b.collapsed);
        toolBlocks.forEach(b => b.collapsed = !allCollapsed);
    }

    public getToolCount(msg: ChatMessage): number {
        return msg.blocks.filter(b => b.type === 'tool').length;
    }

    // =========================================================================
    // Markdown 렌더링
    // =========================================================================

    public renderMarkdown(content: string): string {
        if (!content) return '';
        // /mnt/data/ 경로를 endpoint 파일 서빙 URL로 자동 치환
        let processed = content;
        if (this.currentSessionId) {
            const baseUrl = `/wiz/api/page.agent/endpoint_file?session_id=${this.currentSessionId}&path=`;
            // Markdown 이미지: ![alt](/mnt/data/file.png) → ![alt](endpoint_url)
            processed = processed.replace(/!\[([^\]]*)\]\(\/mnt\/data\/([^)]+)\)/g, `![$1](${baseUrl}$2)`);
            // 일반 경로 참조: /mnt/data/file → endpoint URL (sandbox_url 태그 내부 등)
            processed = processed.replace(/(?<!\()\/mnt\/data\/([^\s"'<>)]+)/g, `${baseUrl}$1`);
        }
        return mdConverter.makeHtml(processed);
    }

    // =========================================================================
    // 스크롤
    // =========================================================================

    public onChatScroll() {
        if (!this.chatContainer?.nativeElement) return;
        const el = this.chatContainer.nativeElement;
        const threshold = 80;
        this.isUserScrolledUp = (el.scrollTop + el.clientHeight) < (el.scrollHeight - threshold);

        // 상단 도달 시 이전 메시지 자동 로딩
        if (el.scrollTop < 100 && this.hasMoreMessages && !this.loadingOlderMessages) {
            this.loadOlderMessages();
        }
    }

    private scrollToBottom() {
        if (this.isUserScrolledUp) return;
        setTimeout(() => {
            if (this.chatContainer && this.chatContainer.nativeElement) {
                const el = this.chatContainer.nativeElement;
                el.scrollTop = el.scrollHeight;
            }
        }, 50);
    }

    // =========================================================================
    // 모델 선택
    // =========================================================================

    public async loadProviders() {
        const { code, data } = await wiz.call('agent_providers');
        if (code === 200) {
            this.providers = data.providers || [];
            this.selectedProvider = data.default_provider || '';
            this.selectedModel = data.default_model || '';
            this.updateCurrentModels();
        }
    }

    public onProviderChange() {
        this.updateCurrentModels();
        if (this.currentModels.length > 0) {
            this.selectedModel = this.currentModels[0].id;
        } else {
            this.selectedModel = '';
        }
    }

    private updateCurrentModels() {
        const prov = this.providers.find(p => p.name === this.selectedProvider);
        this.currentModels = prov ? prov.models : [];
    }

    // =========================================================================
    // Canvas 패널
    // =========================================================================

    public getCanvasUrl(toolName: string): SafeResourceUrl {
        if (!toolName) return this.sanitizer.bypassSecurityTrustResourceUrl('');
        if (this.canvasUrls[toolName]) return this.canvasUrls[toolName];
        const url = `/api/tool-canvas/${encodeURIComponent(toolName)}/index.html`;
        const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.canvasUrls[toolName] = safeUrl;
        return safeUrl;
    }

    // =========================================================================
    // Activity Bar + Panel
    // =========================================================================

    public togglePanel(panelId: string) {
        if (panelId === 'chat') {
            this.activePanel = null;
            this.mobileMenuOpen = false;
            return;
        }
        const newPanel = this.activePanel === panelId ? null : panelId;
        this.activePanel = newPanel;
        this.mobileMenuOpen = false;
        if (newPanel === 'storage') {
            this.loadStorageFiles();
        }
        if (newPanel === 'history') {
            this.loadHistory();
        }
        if (newPanel === 'tools') {
            this.loadTools();
        }
        if (newPanel === 'settings') {
            this.loadSettings();
        }
        this.cdr.detectChanges();
    }

    public openCanvas(block: ToolBlock, event?: Event) {
        if (event) {
            event.stopPropagation();
        }
        if (!block.canvasData || !block.canvasTool) return;
        this.activeCanvas = block;
        this.activePanel = 'canvas';
        this.cdr.detectChanges();

        setTimeout(() => {
            this.sendCanvasData(block);
        }, 500);
    }

    public closeCanvas() {
        this.activeCanvas = null;
        this.activePanel = null;
        this.cdr.detectChanges();
    }

    public refreshCanvas() {
        if (!this.activeCanvas) return;
        const block = this.activeCanvas;
        const toolName = block.canvasTool;
        // URL 캐시 제거하여 iframe 강제 리로드
        if (toolName && this.canvasUrls[toolName]) {
            delete this.canvasUrls[toolName];
        }
        // 일시적으로 activeCanvas를 해제 → iframe 제거 → 재생성
        this.activeCanvas = null;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.activeCanvas = block;
            this.cdr.detectChanges();
            setTimeout(() => {
                this.sendCanvasData(block);
            }, 500);
        }, 50);
    }

    // ── Canvas 리사이즈 ──

    public startResize(event: MouseEvent) {
        event.preventDefault();
        this.isResizing = true;
        const onMove = (e: MouseEvent) => {
            if (!this.isResizing) return;
            const container = (event.target as HTMLElement).parentElement!;
            const rect = container.getBoundingClientRect();
            const barWidth = 48;
            const availableWidth = rect.width - barWidth;
            let pct = ((e.clientX - rect.left - barWidth) / availableWidth) * 100;
            const chatMinPx = 320;
            const maxPanelPct = ((availableWidth - chatMinPx) / availableWidth) * 100;
            pct = Math.max(20, Math.min(Math.min(75, maxPanelPct), pct));
            this.panelWidth = pct;
            this.cdr.detectChanges();
        };
        const onUp = () => {
            this.isResizing = false;
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
    }

    private sendCanvasData(block: ToolBlock) {
        if (!this.canvasIframe?.nativeElement) return;
        const iframe = this.canvasIframe.nativeElement as HTMLIFrameElement;
        iframe.contentWindow?.postMessage({
            type: 'render',
            data: block.canvasData,
        }, '*');
    }

    private setupCanvasListener() {
        window.addEventListener('message', (event) => {
            if (event.data?.type === 'canvas-ready') {
                if (this.activeCanvas) {
                    this.sendCanvasData(this.activeCanvas);
                }
            }
            if (event.data?.type === 'canvas-resize') {
                if (this.activeCanvas) {
                    this.cdr.detectChanges();
                }
            }
            // Canvas에서 컨텍스트 응답 수신
            if (event.data?.type === 'canvas-context') {
                this.canvasContext = event.data.context || null;
                // Promise resolve (requestCanvasContext에서 대기 중)
                if (this._canvasContextResolve) {
                    this._canvasContextResolve(this.canvasContext);
                    this._canvasContextResolve = null;
                }
            }
            // Canvas에서 채팅 액션 요청 수신
            if (event.data?.type === 'canvas-action') {
                const action = event.data;
                if (action.action === 'chat' && action.message) {
                    // Canvas 컨텍스트 저장
                    if (action.context) {
                        this.canvasContext = action.context;
                    }
                    // 채팅 입력란에 메시지 설정 후 전송
                    this.chatInput = action.message;
                    this.cdr.detectChanges();
                    this.sendChat();
                }
            }
        });
    }

    private _canvasContextResolve: ((val: any) => void) | null = null;

    /**
     * Canvas iframe에 get-context 메시지를 보내고 응답을 기다림
     * @returns Canvas 컨텍스트 데이터 또는 null (타임아웃)
     */
    private requestCanvasContext(): Promise<any> {
        return new Promise((resolve) => {
            const iframe = this.canvasIframe?.nativeElement as HTMLIFrameElement;
            if (!iframe?.contentWindow) {
                resolve(null);
                return;
            }
            this._canvasContextResolve = resolve;
            try {
                iframe.contentWindow.postMessage({ type: 'get-context' }, '*');
            } catch (e) {
                console.warn('Canvas context request failed:', e);
                this._canvasContextResolve = null;
                resolve(null);
                return;
            }
            // 500ms 타임아웃
            setTimeout(() => {
                if (this._canvasContextResolve) {
                    this._canvasContextResolve = null;
                    resolve(this.canvasContext); // 기존 컨텍스트 fallback
                }
            }, 500);
        });
    }

    // =========================================================================
    // 키보드 이벤트 (한글 IME 대응)
    // =========================================================================

    public onKeydown(event: KeyboardEvent) {
        if (event.isComposing || this.isComposing) return;

        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.sendChat();
        }
    }

    // =========================================================================
    // 유틸
    // =========================================================================

    public jsonStringify(obj: any): string {
        try {
            return JSON.stringify(obj, null, 2);
        } catch {
            return String(obj);
        }
    }

    // =========================================================================
    // Tool 요약 생성
    // =========================================================================

    private _generateToolSummary(toolName: string, input: any): string {
        if (!toolName) return '도구 실행';

        const summaryMap: { [key: string]: (input: any) => string } = {
            'read_file': (inp) => `파일 읽기${inp?.path ? ': ' + this._shortenPath(inp.path) : ''}`,
            'write_file': (inp) => `파일 쓰기${inp?.path ? ': ' + this._shortenPath(inp.path) : ''}`,
            'list_files': (inp) => `파일 목록 조회${inp?.path ? ': ' + this._shortenPath(inp.path) : ''}`,
            'list_endpoints': () => '엔드포인트 목록 조회',
            'run_command': (inp) => `명령어 실행${inp?.command ? ': ' + this._truncate(inp.command, 40) : ''}`,
            'web_search': (inp) => `웹 검색${inp?.query ? ': ' + this._truncate(inp.query, 40) : ''}`,
            'search_tools': (inp) => `도구 검색${inp?.keyword ? ': ' + inp.keyword : ''}`,
            'stock_search': (inp) => `종목 검색${inp?.query ? ': ' + inp.query : ''}`,
            'stock_price': (inp) => `주가 조회${inp?.code ? ': ' + inp.code : ''}`,
            'stock_chart': (inp) => `차트 조회${inp?.code ? ': ' + inp.code : ''}`,
            'stock_news': (inp) => `뉴스 조회${inp?.query || inp?.code ? ': ' + (inp.query || inp.code) : ''}`,
            'financial_analysis': (inp) => `재무분석${inp?.code ? ': ' + inp.code : ''}`,
            'create_tool': (inp) => `도구 생성${inp?.name ? ': ' + inp.name : ''}`,
        };

        const generator = summaryMap[toolName];
        if (generator) {
            try {
                return generator(input);
            } catch {
                return toolName;
            }
        }

        const readable = toolName.replace(/_/g, ' ');
        if (input && typeof input === 'object') {
            const mainKey = Object.keys(input).find(k =>
                ['query', 'path', 'name', 'code', 'keyword', 'command', 'url', 'text'].includes(k)
            );
            if (mainKey && input[mainKey]) {
                return `${readable}: ${this._truncate(String(input[mainKey]), 40)}`;
            }
        }
        return readable;
    }

    private _shortenPath(path: string): string {
        if (!path) return '';
        const parts = path.split('/').filter(p => p);
        if (parts.length <= 2) return path;
        return '.../' + parts.slice(-2).join('/');
    }

    private _truncate(text: string, maxLen: number): string {
        if (!text) return '';
        return text.length > maxLen ? text.substring(0, maxLen) + '...' : text;
    }

    // =========================================================================
    // Storage 기능 (User Only)
    // =========================================================================

    public async navigateStorage(path: string) {
        this.storagePath = path;
        this.updateBreadcrumb();
        await this.loadStorageFiles();
    }

    private updateBreadcrumb() {
        const parts = this.storagePath.split('/').filter(p => p);
        this.storageBreadcrumb = [];
        let accumulated = '';
        for (const part of parts) {
            accumulated += '/' + part;
            this.storageBreadcrumb.push({ name: part, path: accumulated });
        }
    }

    public async loadStorageFiles() {
        this.storageLoading = true;
        this.storageFiles = [];
        this.cdr.detectChanges();
        try {
            const { code, data } = await wiz.call('storage_list', {
                path: this.storagePath,
            });
            if (code === 200) {
                this.storageFiles = data.files || [];
                this.storageFiles.sort((a: any, b: any) => {
                    if (a.type === b.type) return a.name.localeCompare(b.name);
                    return a.type === 'dir' ? -1 : 1;
                });
            }
        } catch (e) {
            console.error('Storage load error:', e);
        }
        this.storageLoading = false;
        await this.service.render();
    }

    public onStorageItemClick(item: any) {
        if (item.type === 'dir') {
            const newPath = this.storagePath === '/' ? '/' + item.name : this.storagePath + '/' + item.name;
            this.navigateStorage(newPath);
        } else {
            // 파일 클릭 → 뷰어로 열기
            this.openStorageFile(item);
        }
    }

    public async openStorageFile(item: any) {
        const filePath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;
        this.storageFileViewer = {
            open: true, loading: true, saving: false,
            filename: item.name, path: filePath,
            content: '', originalContent: '',
            isImage: false, isBinary: false, mimeType: '', size: 0, modified: false,
        };
        this.cdr.detectChanges();

        try {
            const res = await wiz.call('storage_read', { path: filePath });
            if (res.code === 200) {
                if (res.data.is_binary) {
                    this.storageFileViewer.isBinary = true;
                    this.storageFileViewer.filename = res.data.filename;
                    this.storageFileViewer.size = res.data.size;
                    this.storageFileViewer.mimeType = res.data.mime_type || '';
                } else if (res.data.is_image) {
                    this.storageFileViewer.isImage = true;
                    this.storageFileViewer.filename = res.data.filename;
                    this.storageFileViewer.size = res.data.size;
                    this.storageFileViewer.mimeType = res.data.mime_type || '';
                } else {
                    this.storageFileViewer.content = res.data.content || '';
                    this.storageFileViewer.originalContent = res.data.content || '';
                    this.storageFileViewer.filename = res.data.filename;
                    this.storageFileViewer.size = res.data.size;
                    this.storageFileViewer.mimeType = res.data.mime_type || '';
                }
            }
        } catch (e) {
            console.error('File read error:', e);
        }
        this.storageFileViewer.loading = false;
        this.cdr.detectChanges();
    }

    public onStorageFileContentChange(content: string) {
        this.storageFileViewer.content = content;
        this.storageFileViewer.modified = content !== this.storageFileViewer.originalContent;
        this.cdr.detectChanges();
    }

    public async saveStorageFile() {
        if (!this.storageFileViewer.path || this.storageFileViewer.saving) return;
        this.storageFileViewer.saving = true;
        this.cdr.detectChanges();
        try {
            await wiz.call('storage_write', {
                path: this.storageFileViewer.path,
                content: this.storageFileViewer.content,
            });
            this.storageFileViewer.originalContent = this.storageFileViewer.content;
            this.storageFileViewer.modified = false;
        } catch (e) {
            console.error('File save error:', e);
        }
        this.storageFileViewer.saving = false;
        this.cdr.detectChanges();
    }

    public closeStorageFileViewer() {
        this.storageFileViewer.open = false;
        this.cdr.detectChanges();
    }

    public getStorageImageUrl(filePath: string): string {
        return `/wiz/api/${APP_ID}/storage_download?path=${encodeURIComponent(filePath)}`;
    }

    public getFileIcon(filename: string): string {
        const ext = (filename.split('.').pop() || '').toLowerCase();
        const iconMap: { [key: string]: string } = {
            'pdf': '📕', 'doc': '📘', 'docx': '📘', 'xls': '📗', 'xlsx': '📗',
            'ppt': '📙', 'pptx': '📙', 'zip': '📦', 'tar': '📦', 'gz': '📦', 'tgz': '📦',
            'png': '🖼️', 'jpg': '🖼️', 'jpeg': '🖼️', 'gif': '🖼️', 'svg': '🖼️', 'webp': '🖼️',
            'mp4': '🎬', 'mp3': '🎵', 'wav': '🎵',
            'py': '🐍', 'js': '📜', 'ts': '📜', 'json': '📋', 'md': '📝', 'txt': '📝',
            'html': '🌐', 'css': '🎨', 'csv': '📊',
        };
        return iconMap[ext] || '📄';
    }

    public isArchiveFile(filename: string): boolean {
        const ext = (filename.split('.').pop() || '').toLowerCase();
        return ['zip', 'tar', 'gz', 'tgz', 'bz2'].includes(ext) || filename.endsWith('.tar.gz');
    }

    public async createStorageFolder() {
        const name = await this.showPrompt('폴더 생성', '폴더 이름', '');
        if (!name) return;
        try {
            await wiz.call('storage_mkdir', {
                path: (this.storagePath === '/' ? '' : this.storagePath) + '/' + name,
            });
            await this.loadStorageFiles();
        } catch (e) {
            console.error('Mkdir error:', e);
        }
    }

    public async deleteStorageItem(item: any, event: Event) {
        event.stopPropagation();
        if (!(await this.showConfirm(`"${item.name}"을(를) 삭제하시겠습니까?`))) return;
        try {
            const itemPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;
            await wiz.call('storage_delete', {
                path: itemPath,
            });
            await this.loadStorageFiles();
        } catch (e) {
            console.error('Delete error:', e);
        }
    }

    public async renameStorageItem(item: any, event: Event) {
        event.stopPropagation();
        const newName = await this.showPrompt('이름 변경', '새 이름', item.name);
        if (!newName || newName === item.name) return;
        try {
            const oldPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;
            const newPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + newName;
            await wiz.call('storage_rename', {
                old_path: oldPath,
                new_path: newPath,
            });
            await this.loadStorageFiles();
        } catch (e) {
            console.error('Rename error:', e);
        }
    }

    public downloadStorageItem(item: any, event: Event) {
        event.stopPropagation();
        const itemPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;
        const url = `/wiz/api/${APP_ID}/storage_download?path=${encodeURIComponent(itemPath)}`;
        window.open(url, '_blank');
    }

    // 컨텍스트 메뉴
    public onStorageContextMenu(event: MouseEvent, item: any) {
        event.preventDefault();
        event.stopPropagation();
        this.contextMenu = {
            visible: true,
            x: event.clientX,
            y: event.clientY,
            item: item,
        };
        // 파일이면 연동 가능한 도구 목록 로드
        if (item.type === 'file') {
            this.loadToolsForFile(item.name);
        } else {
            this.storageFileTools = [];
        }
        this.cdr.detectChanges();
    }

    /**
     * 파일 확장자에 매칭되는 Tool 목록 로드
     */
    public async loadToolsForFile(filename: string) {
        this.storageToolsLoading = true;
        this.storageFileTools = [];
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('agent_tools_for_file', { filename });
            if (res.code === 200) {
                this.storageFileTools = res.data?.tools || [];
            }
        } catch (e) {
            this.storageFileTools = [];
        }
        this.storageToolsLoading = false;
        this.cdr.detectChanges();
    }

    /**
     * 스토리지 파일을 Canvas 뷰어로 열기
     * 파일을 세션 endpoint로 복사 후 endpoint 경로로 Canvas 컨텍스트를 설정
     */
    public async openCanvasWithFile(tool: any, item: any) {
        this.closeContextMenu();

        // 파일 경로 구성
        const filePath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;

        // 스토리지 파일을 세션 endpoint로 복사
        let endpointPath = '';
        let fileUrl = '';
        try {
            const copyRes = await wiz.call("canvas_copy_to_endpoint", {
                session_id: this.currentSessionId,
                storage_path: filePath,
            });
            if (copyRes.code === 200) {
                endpointPath = copyRes.data.endpoint_path;
                const epFilename = copyRes.data.filename;
                fileUrl = `/wiz/api/${APP_ID}/endpoint_file?session_id=${encodeURIComponent(this.currentSessionId)}&path=${encodeURIComponent(epFilename)}`;
            } else {
                // 복사 실패 시 storage_download 폴백
                fileUrl = `/wiz/api/${APP_ID}/storage_download?path=${encodeURIComponent(filePath)}`;
            }
        } catch (e) {
            // 에러 시 storage_download 폴백
            fileUrl = `/wiz/api/${APP_ID}/storage_download?path=${encodeURIComponent(filePath)}`;
        }

        // ToolBlock 형태로 Canvas 활성화
        const canvasBlock: ToolBlock = {
            type: 'tool',
            id: `file_${Date.now()}`,
            name: tool.name,
            summary: `파일 열기: ${item.name}`,
            input: { file_path: filePath },
            status: 'complete',
            result: '',
            collapsed: false,
            canvasData: {
                file: {
                    url: fileUrl,
                    path: filePath,
                    name: item.name,
                },
            },
            canvasTool: tool.name,
        };

        this.activeCanvas = canvasBlock;
        this.canvasContext = {
            tool_name: tool.name,
            file_path: endpointPath || filePath,
        };

        // Canvas 패널 활성화
        this.activePanel = 'canvas';
        this.cdr.detectChanges();

        // iframe 로드 후 데이터 전송
        setTimeout(() => {
            this.sendCanvasData(canvasBlock);
        }, 300);
    }

    public closeContextMenu() {
        this.contextMenu = { visible: false, x: 0, y: 0, item: null };
        this.cdr.detectChanges();
    }

    @HostListener('document:click')
    public onDocumentClick() {
        if (this.contextMenu.visible) {
            this.closeContextMenu();
        }
    }

    @HostListener('document:contextmenu')
    public onDocumentContextMenu() {
        if (this.contextMenu.visible) {
            this.closeContextMenu();
        }
    }

    // =========================================================================
    // History 패널
    // =========================================================================

    public async loadHistory() {
        this.historyLoading = true;
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('conversation_list');
            this.historyList = res.data?.sessions || [];
        } catch (e) {
            this.historyList = [];
        }
        this.historyLoading = false;
        this.cdr.detectChanges();
    }

    public async deleteHistorySession(session: any, event: Event) {
        event.stopPropagation();
        if (!(await this.showConfirm('이 대화 기록을 삭제하시겠습니까?'))) return;
        try {
            await wiz.call('conversation_delete', {
                session_id: session.session_id,
            });
            await this.loadHistory();
        } catch (e) {
            console.error('Delete session error:', e);
        }
    }

    public async restoreHistorySession(session: any, event: Event) {
        event.stopPropagation();
        if (!session) return;

        // 세션 데이터 로드 후 복원 (최근 메시지만)
        this.historyLoading = true;
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('conversation_load', {
                session_id: session.session_id,
                limit: String(this.MESSAGES_PER_PAGE),
            });
            const data = res.data?.session;
            if (data && data.messages && data.messages.length > 0) {
                this.currentSessionId = data.session_id || session.session_id;
                this.restoreSessionData(data);
                this.activePanel = null;
                this.updateUrlSessionId();
            }
        } catch (e) {
            console.error('Restore session error:', e);
        }
        this.historyLoading = false;
        this.cdr.detectChanges();
    }

    public formatTimestamp(ts: string): string {
        if (!ts) return '';
        try {
            const d = new Date(ts);
            return d.toLocaleDateString('ko-KR') + ' ' + d.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
        } catch {
            return ts;
        }
    }

    // =========================================================================
    // Tools 패널
    // =========================================================================

    public async loadTools() {
        this.toolsLoading = true;
        this.toolDetail = null;
        this.toolDetailMode = false;
        this.cdr.detectChanges();
        try {
            const [toolsRes, disabledRes] = await Promise.all([
                wiz.call('agent_tools'),
                wiz.call('agent_disabled_tools'),
            ]);
            this.toolsList = toolsRes.data?.tools || [];
            this.disabledTools = disabledRes.data?.disabled_tools || [];
        } catch (e) {
            this.toolsList = [];
            this.disabledTools = [];
        }
        this.toolsLoading = false;
        this.cdr.detectChanges();
    }

    public get filteredToolsList(): any[] {
        if (!this.toolSearchQuery || !this.toolSearchQuery.trim()) {
            return this.toolsList;
        }
        const q = this.toolSearchQuery.trim().toLowerCase();
        return this.toolsList.filter((tool: any) => {
            const title = (tool.title || '').toLowerCase();
            const name = (tool.name || '').toLowerCase();
            const desc = (tool.description || '').toLowerCase();
            const tags = (tool.tags || []).map((t: string) => t.toLowerCase()).join(' ');
            return title.includes(q) || name.includes(q) || desc.includes(q) || tags.includes(q);
        });
    }

    public isToolEnabled(toolName: string): boolean {
        return !this.disabledTools.includes(toolName);
    }

    public async toggleTool(toolName: string) {
        const currentlyEnabled = this.isToolEnabled(toolName);
        try {
            const res = await wiz.call('agent_tool_toggle', {
                tool_name: toolName,
                enabled: currentlyEnabled ? 'false' : 'true',
            });
            this.disabledTools = res.data?.disabled_tools || [];
        } catch (e) {
            console.error('Tool toggle error:', e);
        }
        this.cdr.detectChanges();
    }

    public toggleToolExpand(toolName: string) {
        if (this.expandedTools.has(toolName)) {
            this.expandedTools.delete(toolName);
        } else {
            this.expandedTools.add(toolName);
        }
        this.cdr.detectChanges();
    }

    public isToolExpanded(toolName: string): boolean {
        return this.expandedTools.has(toolName);
    }

    public async loadToolDetail(toolName: string) {
        this.toolsLoading = true;
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('agent_tool_detail', { tool_name: toolName });
            this.toolDetail = res.data?.detail || null;
            this.toolDetailMode = true;
            // input_schema에서 기본 테스트 입력 생성
            const schema = this.toolDetail?.input_schema;
            if (schema?.properties) {
                const defaultInput: any = {};
                for (const [key, prop] of Object.entries(schema.properties) as any) {
                    defaultInput[key] = prop.default !== undefined ? prop.default : '';
                }
                this.toolTestInput = JSON.stringify(defaultInput, null, 2);
            } else {
                this.toolTestInput = '{}';
            }
            this.toolTestResult = '';
        } catch (e) {
            this.toolDetail = null;
        }
        this.toolsLoading = false;
        this.cdr.detectChanges();
    }

    public closeToolDetail() {
        this.toolDetail = null;
        this.toolDetailMode = false;
        this.toolTestInput = '{}';
        this.toolTestResult = '';
        this.cdr.detectChanges();
    }

    public async deleteTool() {
        if (!this.toolDetail) return;
        const toolName = this.toolDetail.name;
        const confirmed = await this.showConfirm(`'${toolName}' Tool을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`);
        if (!confirmed) return;
        try {
            await wiz.call('agent_tool_delete', { tool_name: toolName });
            this.closeToolDetail();
            await this.loadTools();
        } catch (e: any) {
            this.service.alert.show({ title: '오류', message: e.message || '삭제 실패', status: 'error' });
        }
    }

    public async runToolTest() {
        if (!this.toolDetail || this.toolTestRunning) return;
        this.toolTestRunning = true;
        this.toolTestResult = '';
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('agent_tool_test', {
                tool_name: this.toolDetail.name,
                test_input: this.toolTestInput,
            });
            this.toolTestResult = JSON.stringify(res.data?.result, null, 2);
        } catch (e: any) {
            this.toolTestResult = `Error: ${e.message || e}`;
        }
        this.toolTestRunning = false;
        this.cdr.detectChanges();
    }

    public getInputSchemaParams(): any[] {
        if (!this.toolDetail?.input_schema?.properties) return [];
        const props = this.toolDetail.input_schema.properties;
        const required = this.toolDetail.input_schema.required || [];
        return Object.entries(props).map(([key, val]: any) => ({
            name: key,
            type: val.type || '',
            description: val.description || '',
            required: required.includes(key),
        }));
    }

    // =========================================================================
    // Settings 패널 (agent.json)
    // =========================================================================

    public async loadSettings() {
        this.settingsLoading = true;
        this.cdr.detectChanges();
        try {
            const res = await wiz.call('config_load');
            const cfg = res.data?.config || {};
            this.settingsConfig = JSON.parse(JSON.stringify(cfg));
            this.settingsJson = JSON.stringify(cfg, null, 2);
        } catch (e) {
            this.settingsConfig = {};
            this.settingsJson = '{}';
        }
        // 파이프라인 프롬프트도 함께 로드
        await this.loadPipelinePrompts();
        this.settingsLoading = false;
        this.cdr.detectChanges();
    }

    public async saveSettings() {
        this.settingsSaving = true;
        this.cdr.detectChanges();
        let configToSave: any;
        if (this.settingsAdvancedMode) {
            try {
                configToSave = JSON.parse(this.settingsJson);
            } catch (e) {
                await this.service.modal.error('JSON 형식이 올바르지 않습니다.');
                this.settingsSaving = false;
                this.cdr.detectChanges();
                return;
            }
        } else {
            configToSave = JSON.parse(JSON.stringify(this.settingsConfig));
        }
        try {
            await wiz.call('config_save', { config: JSON.stringify(configToSave) });
            this.settingsConfig = configToSave;
            this.settingsJson = JSON.stringify(configToSave, null, 2);
            await this.service.modal.success('설정이 저장되었습니다.');
        } catch (e) {
            await this.service.modal.error('설정 저장에 실패했습니다.');
        }
        this.settingsSaving = false;
        this.cdr.detectChanges();
    }

    public toggleSettingsMode() {
        if (this.settingsAdvancedMode) {
            // JSON → 구조화: JSON 파싱 후 config 반영
            try {
                this.settingsConfig = JSON.parse(this.settingsJson);
            } catch (e) { /* 유지 */ }
        } else {
            // 구조화 → JSON: config를 JSON 문자열로 반영
            this.settingsJson = JSON.stringify(this.settingsConfig, null, 2);
        }
        this.settingsAdvancedMode = !this.settingsAdvancedMode;
        this.cdr.detectChanges();
    }

    // =========================================================================
    // Pipeline Prompts (파이프라인 프롬프트 편집)
    // =========================================================================

    public async loadPipelinePrompts() {
        try {
            const res = await wiz.call('pipeline_prompts_load');
            this.pipelinePrompts = res.data?.prompts || {};
        } catch (e) {
            this.pipelinePrompts = {};
        }
        this.cdr.detectChanges();
    }

    public selectPromptNode(key: string) {
        if (this.selectedPromptKey === key) {
            this.selectedPromptKey = null;
            this.promptEditorTemplate = '';
        } else {
            this.selectedPromptKey = key;
            const prompt = this.pipelinePrompts[key];
            this.promptEditorTemplate = prompt?.template || '';
        }
        this.cdr.detectChanges();
    }

    public async savePromptEdit() {
        if (!this.selectedPromptKey) return;
        this.promptEditorSaving = true;
        this.cdr.detectChanges();
        try {
            await wiz.call('pipeline_prompt_save', {
                key: this.selectedPromptKey,
                template: this.promptEditorTemplate,
            });
            // 목록 갱신
            await this.loadPipelinePrompts();
            // 에디터에 갱신된 값 반영
            const prompt = this.pipelinePrompts[this.selectedPromptKey];
            if (prompt) this.promptEditorTemplate = prompt.template || '';
        } catch (e) {
            // 에러 처리
        }
        this.promptEditorSaving = false;
        this.cdr.detectChanges();
    }

    public async resetPromptToDefault() {
        if (!this.selectedPromptKey) return;
        this.promptEditorSaving = true;
        this.cdr.detectChanges();
        try {
            await wiz.call('pipeline_prompt_reset', {
                key: this.selectedPromptKey,
            });
            await this.loadPipelinePrompts();
            const prompt = this.pipelinePrompts[this.selectedPromptKey];
            if (prompt) this.promptEditorTemplate = prompt.template || '';
        } catch (e) {
            // 에러 처리
        }
        this.promptEditorSaving = false;
        this.cdr.detectChanges();
    }

    public getPromptKeys(): string[] {
        return Object.keys(this.pipelinePrompts);
    }

    public getPromptLabel(key: string): string {
        const labels: any = {
            intent: 'INTENT',
            review: 'REVIEW',
            plan: 'PLAN',
            reconstruct: 'RECONSTRUCT',
            synthesize: 'SYNTHESIZE',
            role: 'ROLE',
            context_summary: 'CONTEXT SUMMARY',
        };
        return labels[key] || key.toUpperCase();
    }

    public getProviderNames(): string[] {
        return Object.keys(this.settingsConfig?.llm?.providers || {});
    }

    public getProviderModels(providerName: string): any[] {
        const models = this.settingsConfig?.llm?.providers?.[providerName]?.models || {};
        return Object.entries(models).map(([id, conf]: any) => ({
            id,
            model_id: conf.model_id || id,
            description: conf.description || '',
            context_length: conf.context_length || 0,
            max_output_tokens: conf.max_output_tokens || 0,
        }));
    }

    public updateConfigValue(path: string, value: any) {
        const keys = path.split('.');
        let obj = this.settingsConfig;
        for (let i = 0; i < keys.length - 1; i++) {
            if (!obj[keys[i]]) obj[keys[i]] = {};
            obj = obj[keys[i]];
        }
        obj[keys[keys.length - 1]] = value;
    }

    public getConfigValue(path: string, defaultVal: any = ''): any {
        const keys = path.split('.');
        let obj = this.settingsConfig;
        for (const k of keys) {
            if (obj && typeof obj === 'object' && k in obj) {
                obj = obj[k];
            } else {
                return defaultVal;
            }
        }
        return obj;
    }

    public triggerFileUpload() {
        if (this.storageFileInput?.nativeElement) {
            this.storageFileInput.nativeElement.click();
        }
    }

    public async onStorageFileSelected(event: any) {
        const files = event.target?.files;
        if (!files || files.length === 0) return;
        await this.uploadFiles(files);
        if (this.storageFileInput?.nativeElement) {
            this.storageFileInput.nativeElement.value = '';
        }
    }

    // 드래그 앤 드롭 (외부 파일 업로드)
    public onStorageDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        // 내부 파일 이동 중이면 외부 드래그 오버레이 표시 안 함
        if (this.storageDragItem) return;
        this.isDraggingOver = true;
    }

    public onStorageDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDraggingOver = false;
    }

    public async onStorageDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDraggingOver = false;
        // 내부 파일 이동 중이면 무시 (onItemDrop에서 처리)
        if (this.storageDragItem) return;
        const files = event.dataTransfer?.files;
        if (!files || files.length === 0) return;
        await this.uploadFiles(files);
    }

    // 드래그 앤 드롭 (내부 파일/폴더 이동)
    public onItemDragStart(event: DragEvent, item: any) {
        this.storageDragItem = item;
        event.dataTransfer!.effectAllowed = 'move';
        event.dataTransfer!.setData('text/plain', item.name);
    }

    public onItemDragEnd(event: DragEvent) {
        this.storageDragItem = null;
        this.storageDragOverFolder = null;
        this.cdr.detectChanges();
    }

    public onItemDragOver(event: DragEvent, targetItem: any) {
        if (!this.storageDragItem) return;
        if (targetItem.type !== 'dir') return;
        if (targetItem.name === this.storageDragItem.name) return;
        event.preventDefault();
        event.stopPropagation();
        event.dataTransfer!.dropEffect = 'move';
        this.storageDragOverFolder = targetItem.name;
        this.cdr.detectChanges();
    }

    public onItemDragLeave(event: DragEvent) {
        this.storageDragOverFolder = null;
        this.cdr.detectChanges();
    }

    public async onItemDrop(event: DragEvent, targetItem: any) {
        event.preventDefault();
        event.stopPropagation();
        const dragItem = this.storageDragItem;
        this.storageDragItem = null;
        this.storageDragOverFolder = null;

        if (!dragItem || targetItem.type !== 'dir' || dragItem.name === targetItem.name) return;

        const srcPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + dragItem.name;
        const destPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + targetItem.name + '/' + dragItem.name;

        try {
            await wiz.call('storage_move', {
                source_path: srcPath,
                target_path: destPath,
            });
            await this.loadStorageFiles();
        } catch (e) {
            console.error('Move error:', e);
        }
    }

    // 압축 풀기 / 압축하기
    public async storageUnzipFile(item: any) {
        if (!item || item.type !== 'file') return;
        const filePath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;
        this.storageLoading = true;
        this.cdr.detectChanges();
        try {
            await wiz.call('storage_unzip', { path: filePath });
        } catch (e) {
            console.error('Unzip error:', e);
        }
        await this.loadStorageFiles();
    }

    public async storageZipItem(item: any) {
        if (!item) return;
        const itemPath = (this.storagePath === '/' ? '' : this.storagePath) + '/' + item.name;
        this.storageLoading = true;
        this.cdr.detectChanges();
        try {
            await wiz.call('storage_zip', { path: itemPath });
        } catch (e) {
            console.error('Zip error:', e);
        }
        await this.loadStorageFiles();
    }

    private async uploadFiles(files: FileList) {
        this.uploadProgress = [];
        for (let i = 0; i < files.length; i++) {
            this.uploadProgress.push({ name: files[i].name, percent: 0 });
        }
        this.cdr.detectChanges();

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            try {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('path', this.storagePath);

                const xhr = new XMLHttpRequest();
                xhr.upload.onprogress = (e) => {
                    if (e.lengthComputable && this.uploadProgress[i]) {
                        this.uploadProgress[i].percent = Math.round((e.loaded / e.total) * 100);
                        this.cdr.detectChanges();
                    }
                };

                await new Promise<void>((resolve, reject) => {
                    xhr.onload = () => {
                        if (xhr.status >= 200 && xhr.status < 300) {
                            resolve();
                        } else {
                            console.error('Upload failed:', xhr.status, xhr.responseText);
                            reject(new Error(`Upload failed: ${xhr.status}`));
                        }
                    };
                    xhr.onerror = () => reject(new Error('Upload network error'));
                    xhr.open('POST', `/wiz/api/${APP_ID}/storage_upload`);
                    xhr.send(formData);
                });
            } catch (e) {
                console.error('Upload error:', e);
            }
        }

        this.uploadProgress = [];
        await this.loadStorageFiles();
    }

    public formatFileSize(bytes: number): string {
        if (!bytes || bytes === 0) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    }

    // =========================================================================
    // 대화 로그 저장
    // =========================================================================

    private async saveConversationLog() {
        if (!this.currentSessionId || this.chatMessages.length === 0) return;
        try {
            const logMessages = this.chatMessages.map(m => ({
                role: m.role,
                content: m.content || '',
                blocks: m.blocks.map(b => this.serializeBlock(b)),
            }));
            await wiz.call('conversation_save', {
                session_id: this.currentSessionId,
                messages: JSON.stringify(logMessages),
            });
        } catch (e) {
            console.error('Conversation log save error:', e);
        }
    }

    private serializeBlock(b: MessageBlock): any {
        switch (b.type) {
            case 'text':
                return { type: 'text', content: (b as TextBlock).content };
            case 'tool': {
                const t = b as ToolBlock;
                return { type: 'tool', id: t.id, name: t.name, summary: t.summary, input: t.input, status: t.status, result: t.result || '', canvasData: t.canvasData || null, canvasTool: t.canvasTool || null };
            }
            case 'analyze': {
                const a = b as AnalyzeBlock;
                return { type: 'analyze', action: a.action, reasoning: a.reasoning, summary: a.summary, label: a.label };
            }
            case 'plan': {
                const p = b as PlanBlock;
                return { type: 'plan', steps: p.steps };
            }
            case 'step': {
                const s = b as StepBlock;
                return { type: 'step', step_id: s.step_id, title: s.title, status: s.status };
            }
            case 'thinking': {
                const th = b as ThinkingBlock;
                return { type: 'thinking', content: th.content, collapsed: th.collapsed };
            }
            case 'sub_agent': {
                const sa = b as SubAgentBlock;
                return { type: 'sub_agent', goal: sa.goal, status: sa.status, result: sa.result || '', collapsed: sa.collapsed };
            }
            case 'plan_retry': {
                const pr = b as PlanRetryBlock;
                return { type: 'plan_retry', step_id: pr.step_id, reason: pr.reason, collapsed: pr.collapsed };
            }
            case 'plan_revision': {
                const pv = b as PlanRevisionBlock;
                return { type: 'plan_revision', mode: pv.mode, reason: pv.reason, collapsed: pv.collapsed };
            }
            case 'context_summary': {
                const cs = b as ContextSummaryBlock;
                return { type: 'context_summary', summary: cs.summary, collapsed: cs.collapsed };
            }
            default:
                return { type: b.type };
        }
    }
}

export default PageAgentComponent;